<template>
  <kst-section collapsible 
    :title="Info.Section.Invoice.Title"
    :help-collapsed="sectionHelp_Collapsed"
    :help-expanded="sectionHelp_Expanded"
  >
    <InvoiceSearchList
      ref="mdlInvoiceSearchList"
      :warehouseList="warehouseList"
      @submit="handleSubmit"
    />

    <kst-number-with-date search-mode
      :catalog="Catalog"
      :data="userData"
      dateField="SalesOrderDate"
      numberField="SOID"
      @search="handleSearch"
      @clear="handleClear"
    />
    <kst-input class="is-hidden"
      field="SOID" :data="userData" :catalog="Catalog"
    />
  </kst-section>
</template>

<script>
import Catalog from "../DlvCatalog.js";
import Info from "../DlvInfo.js";
import Model from "../DlvModel.js";
import Services from "../../../services/Api/DeliveryServices.js";

import InvoiceSearchList from "../../Invoice/SearchList/InvScL.vue";

export default {
  components: {
    InvoiceSearchList
  },
  props: {
    userData: Object,
    warehouseList: Array
  },
  data: () => ({
    Catalog: Catalog,
    Info: Info
  }),
  computed: {
    sectionHelp_Collapsed() {
      return Model.getInvoiceSectionHelp(this.userData);
    },
    sectionHelp_Expanded() {
      return Info.Message.New_Invoice;
    }
  },
  methods: {
    /*** by invoice modal ***/

    handleSubmit(row) {
      this.$emit(this.$kst.Enum.Event.Submit, row);
    },

    /*** custom ***/

    handleClear() {
      this.$emit(this.$kst.Enum.Event.Reset);
    },
    handleSearch() {
      this.$refs.mdlInvoiceSearchList.show(
        Services.getRelatedInvoiceList,
        Services.getRelatedInvoiceDetails
      );
    }
  }
}
</script>